import { httpClient } from "./http-client";
import { NEW_API_ENDPOINTS } from "../../shared/constants/api";
import type { TokenResponse } from "../../domain/types/auth";
import type {
  CompanyInvitation,
  InvitationPreview,
  InvitationSendResult,
  InvitationSignupRequest,
  StaffMember,
} from "../../domain/types/staff";

type Wrapped<T> = { data: T };

const staffEp = NEW_API_ENDPOINTS.companyStaffController;
const inviteEp = NEW_API_ENDPOINTS.invitationController;

/** 구성원 관리 API (회사 소유자·관리자 조회, 관리자 초대) */
export const companyStaffApi = {
  staff: async (companyId: number) =>
    (await httpClient.get<Wrapped<StaffMember[]>>(staffEp.GET_STAFF(companyId))).data.data,

  invitations: async (companyId: number) =>
    (await httpClient.get<Wrapped<CompanyInvitation[]>>(staffEp.GET_INVITATIONS(companyId))).data.data,

  invite: async (companyId: number, body: { email: string; departmentId?: number }) =>
    (await httpClient.post<Wrapped<InvitationSendResult>>(staffEp.POST_INVITATION(companyId), body)).data.data,

  resend: async (companyId: number, id: number) =>
    (await httpClient.post<Wrapped<InvitationSendResult>>(staffEp.POST_RESEND(companyId, id))).data.data,

  revoke: async (companyId: number, id: number) =>
    (await httpClient.delete<Wrapped<CompanyInvitation>>(staffEp.DELETE_INVITATION(companyId, id))).data.data,
};

/** 초대 수락 API (공개). 수락이 끝나면 로그인 토큰을 돌려준다 */
export const invitationApi = {
  preview: async (token: string) =>
    (await httpClient.get<Wrapped<InvitationPreview>>(inviteEp.GET(token))).data.data,

  acceptWithPassword: async (token: string, password: string) =>
    (await httpClient.post<Wrapped<TokenResponse>>(inviteEp.POST_ACCEPT_PASSWORD(token), { password })).data.data,

  acceptWithSocial: async (token: string, body: { providerUserToken: string; providerUserId: string }) =>
    (await httpClient.post<Wrapped<TokenResponse>>(inviteEp.POST_ACCEPT_SOCIAL(token), body)).data.data,

  acceptWithSignup: async (token: string, body: InvitationSignupRequest) =>
    (await httpClient.post<Wrapped<TokenResponse>>(inviteEp.POST_ACCEPT_SIGNUP(token), body)).data.data,
};
